<template>
  <div class="position-relative">
    <div :id="mapId" class=" mapbox-component">
      <div  :class="viewMode=='detail'?'d-none':'marker-custom'"></div>
      <!-- <div class="marker-custom"></div> -->
      <!--      <div class="input-group mb-3 input-search" >-->
      <!--      <input type="text" class="form-control" aria-label="Text input with checkbox">-->
      <!--      </div>-->
    </div>
  </div>
</template>
<style scoped>
.mapbox-component {
  position: relative;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 300px;
}
.marker-custom {
  top: 40%;
  left: 45%;
  position: absolute;
  background-image: url('../../public/img/marker.png');
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}
::v-deep .mapboxgl-marker {
  /* top: 31%;
    left: 45%;
    position: absolute; */
  background-image: url("../../public/img/marker.png");
  /* background-size: cover; */
  background-size: 35px 35px;
  background-position: center;
  width: 27px;
  height: 35px;
  cursor: pointer;
  z-index: 1;
}

::v-deep .mapboxgl-marker svg{
  display: none;
}
/*.input-search {*/
/*top: 5px;*/
/*right: 5px;*/
/*position: absolute;*/
/*background-size: cover;*/
/*width: auto;*/
/*height: 50px;*/
/*border-radius: 50%;*/
/*cursor: pointer;*/
/*z-index: 1;*/
/*opacity: 95%;*/
/*}*/
</style>
<script>
import mapboxgl from "mapbox-gl";
import MapApi from "../moduleApi/MapApi";
import MethodService from "../service/MethodService";

export default {
  props: {
    value: Object,
    cordinatesValue: Array,
    id: String,
    viewMode: String,
  },
  data() {
    return {
      mData: {
        dataDefault: {
          token:
            "pk.eyJ1Ijoic2l0ZW5zYyIsImEiOiJjbDV2dHlja3MwZDdiM2lwOWtqaGJ4dTNnIn0.baIM03zTvYrPzEJZOlDtYw",
          style: "mapbox://styles/mapbox/streets-v11",
          // style: {
          //     'version': 8,
          //     'sources': {
          //         'raster-tiles': {
          //             'type': 'raster',
          //             'tiles': [
          //                 'https://maps.vnpost.vn/api/tm/{z}/{x}/{y}.png?apikey=b232eb301471771069ab27b0715962f24a32055ad975464b'
          //             ],
          //             'tileSize': 256,
          //             'attribution': ''
          //         }
          //     },
          //     'layers': [
          //         {
          //             'id': 'simple-tiles',
          //             'type': 'raster',
          //             'source': 'raster-tiles',
          //             'minzoom': 0,
          //             'maxzoom': 22
          //         }
          //     ]
          // },
          mapDataObject: {
            value: [],
            geoJsonData: {
              type: "",
              geometry: {}
            }
          },
          cordinatesValueProps: []
        }
      },
      mapId: this.id ? this.id : "map_" + parseInt(Math.random() * 1e6),
      map: null,
      marker: null,
    };
  },

  methods: {
    // Prop truyền vào dạng [lat, lng]; Mapbox cần [lng, lat] nên cần đảo lại
    fn_toLngLat(coords) {
      if (!Array.isArray(coords) || coords.length !== 2) return null;
      return [coords[1], coords[0]];
    },

    fn_center() {
      return this.fn_toLngLat(this.cordinatesValue) || [105.75, 21];
    },

    async fn_initMap(map) {
      var _this = this;
      if(_this.map){
        _this.map.remove();
      }
      mapboxgl.accessToken = this.mData.dataDefault.token;
      if (MethodService.isUndefined(map)) {
        const center = _this.fn_center();
        _this.map = new mapboxgl.Map({
          container: this.mapId, // container id
          style: _this.mData.dataDefault.style, // stylesheet location
          center: center, // starting position [lng, lat]
          zoom: 15 // starting zoom
        });

        _this.marker = null;
        if(this.viewMode == "detail"){
          _this.marker = new mapboxgl.Marker().setLngLat(center).addTo(_this.map);
        }

      }
      let geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        marker: null,
        mapboxgl: mapboxgl
      });
      _this.map.addControl(geocoder);

      _this.map.addControl(new mapboxgl.NavigationControl());
      _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(
        _this.map
      );
      _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      _this.map.on("mouseup", async function(e) {
        _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(
          _this.map
        );
        _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      });
      _this.map.on("wheel", async function(e) {
        _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(
          _this.map
        );
        _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      });
      _this.map.on("load", function() {
        // Listen for the `result` event from the Geocoder
        // `result` event is triggered when a user makes a selection
        //  Add a marker at the result's coordinates
        geocoder.on("result", async function(e) {
          let res = await MapApi.searchByLngLat(
            {
              long: e.result.center[0],
              lat: e.result.center[1]
            },
            mapboxgl.accessToken
          );
          let featureLast = res.features.pop();
          let result = {
            value: [e.result.center[1], e.result.center[0]],
            geoJson: {
              type: featureLast.geometry.type,
              coordinates: res.query
            }
          };
          _this.mData.dataDefault.mapDataObject = result;
          _this.$emit("update", _this.mData.dataDefault.mapDataObject);
        });
        _this.map.resize();
      });
      _this.mData.mapBox = map;
    },
    fn_isNull(value) {
      return MethodService.isNull(value);
    },

    async fn_getGeoJsonData(map) {
      let result = await MapApi.searchByLngLat(
        {
          long: map.getCenter().lng,
          lat: map.getCenter().lat
        },
        mapboxgl.accessToken
      );
      let featureLast = result.features.pop();
      // debugger
      return {
        value: [map.getCenter().lat, map.getCenter().lng],
        geoJson: {
          type: featureLast.geometry.type,
          coordinates: result.query
        }
      };
    }
  },
  watch: {
    // Toạ độ từ API thường về sau khi map đã mount ----> dời tâm va marker theo
    cordinatesValue() {
      if (!this.map) return;
      const center = this.fn_toLngLat(this.cordinatesValue);
      if (!center) return;
      this.map.setCenter(center);
      if (this.marker) this.marker.setLngLat(center);
    },
  },
  created() {},
  mounted: async function() {
    await this.fn_initMap();
  },
};
</script>


